import Dashboard from '../dashboard/Dashboard';
const AccountantDashboard = () => <Dashboard />;
export default AccountantDashboard; 